import React from "react";
import Grid from "../../GridCards/Grid";
const Mi_empresa = () => {
  return <Grid />;
};

export default Mi_empresa;
